export function escapeSelector(selector){return selector.replace(/:/g,"\\:")}export default escapeSelector;